<template>
  <div>
    <div class="step-progress-line">
      <div
        v-for="(step, idx) in steps"
        :key="idx"
        class="step-progress-segment"
        :class="{
          'step-progress-segment--active': step.status === 'active' || step.status === 'completed' || step.status === 'current',
          'step-progress-segment--active-not-current': (step.status === 'active' || step.status === 'completed') && idx + 1 !== currentStep
        }"
      />
    </div>
    <div class="step-indicators">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-indicator"
        :class="{
          'step-indicator--active': step.status === 'active' || step.status === 'completed' || step.status === 'current',
          'step-indicator--current': step.status === 'current',
          'step-indicator--completed': step.status === 'completed',
          'step-indicator--active-not-current': (step.status === 'active' || step.status === 'completed') && index + 1 !== currentStep
        }"
      >
        <div class="step-indicator__icon">
          <feather-icon
            :icon="step.icon"
            size="20"
          />
        </div>
        <span class="step-indicator__label">{{ step.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProgressBar',

  props: {
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentStep: {
      type: Number,
      required: true,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>

.step-progress-line {
  display: flex;
  gap: 6px;
  height: 6px;
  overflow: hidden;
  margin-bottom: 20px;
}

.step-progress-segment {
  flex: 1;
  background-color: #D9D9D9;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  border-radius: 100px;

  &--active {
    background-color: #7367f0;
  }

  &--active-not-current {
    opacity: 0.4;
  }
}

.step-indicators {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.step-indicator {
  flex: 1;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.step-indicator__icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #BABABA4D;
  color: #BABABA;
  transition: all 0.2s ease;
}

.step-indicator--active .step-indicator__icon {
  background-color: #6E44FF33;
  border-color: #c4b5fd;
  color: #7367f0;
}

.step-indicator__label {
  font-size: 13px;
  font-weight: 500;
  color: #BABABA;
  transition: color 0.2s ease;
}

.step-indicator--active .step-indicator__label {
  color: #16213e;
}

.step-indicator--active-not-current {
  opacity: 0.4;
}
</style>
